import { anglesService } from '@/shared/api/services';
import { conceptsService } from '@/shared/api/services/concepts.service';
import { cacheInvalidation } from '@/shared/lib/cache-invalidation';
import type { Angle, ConceptAngle, AngleStoreResponse } from '@/types/concept';
import type { ConceptAngleTypeType } from '@/shared/constants';

export async function createAngleForConcept(
  conceptId: string,
  fileName: string,
  md5: string,
  contentType: string,
  angleType?: ConceptAngleTypeType,
  width?: number,
  height?: number,
  aspectRatio?: string,
  // STRICT add-view intent — see ConceptsService.createAngleForConcept.
  intent?: 'view'
): Promise<AngleStoreResponse> {
  return conceptsService.createAngleForConcept(
    conceptId,
    fileName,
    md5,
    contentType,
    angleType,
    width,
    height,
    aspectRatio,
    undefined,
    intent
  );
}

export async function replaceAngle(
  conceptId: string,
  conceptAngleId: string,
  fileName: string,
  md5: string,
  contentType: string,
  width?: number,
  height?: number,
  aspectRatio?: string
): Promise<AngleStoreResponse> {
  const response = await conceptsService.replaceDerivativeAngle(
    conceptId,
    conceptAngleId,
    fileName,
    md5,
    contentType,
    width,
    height,
    aspectRatio
  );
  cacheInvalidation.afterUpdateAngle(response.id, conceptId);
  return response;
}

export async function swapAngle(
  conceptId: string,
  oldConceptAngleId: string,
  newAngleId: string
): Promise<ConceptAngle> {
  const newConceptAngle = await conceptsService.swapConceptAngle(
    conceptId,
    oldConceptAngleId,
    newAngleId
  );
  cacheInvalidation.afterUpdateAngle(newConceptAngle.id, conceptId);
  return newConceptAngle;
}

export async function updateAngle(
  angleId: string,
  nameOrAttrs:
    | string
    | null
    | { name?: string | null; description?: string | null }
): Promise<Angle> {
  const attrs =
    typeof nameOrAttrs === 'object' &&
    nameOrAttrs !== null &&
    !Array.isArray(nameOrAttrs) &&
    ('name' in nameOrAttrs || 'description' in nameOrAttrs)
      ? nameOrAttrs
      : { name: nameOrAttrs as string | null };

  const updatedAngle = await anglesService.updateAngle(angleId, attrs);
  cacheInvalidation.afterUpdateAngle(angleId);
  return updatedAngle;
}
